import axios from "axios";
import store from "@/store";

const state = {
    user: null,
    posts: null,
};

const getters = {
    isAuthenticated: (state) => !!state.user,
    token: (state) => state.user,
    name: (state) => state.name,
    StatePosts: (state) => state.posts,
    StateUser: (state) => state.user,
};

const actions = {
    async Register({dispatch}, form) {
        let result = await axios.post('auth', form)

        if(result.data.result.token){
            await dispatch('LogIn', {token:result.data.result.token, firstName:result.data.result.firstName})
        }
        return result
       // await dispatch('LogIn', result.result.token)
    },
    async RegisterUser({dispatch}, form) {
        let result = await axios.post('register', form)

        if(result.data.result.token){
            await dispatch('LogIn', {token:result.data.result.token, firstName:form.firstName})
        }
        return result
        // await dispatch('LogIn', result.result.token)
    },
    async EditUser({commit},form) {
        let result = await axios.post('updateUser', form, { headers: { authorization: store.getters.token } })
        if(!result.data.result.error) {
            await commit("setName", result.data.result.result.firstName);
        }
        return result
        // await dispatch('LogIn', result.result.token)
    },
    async getUser() {
        let result = await axios.get('user', { headers: { authorization: store.getters.token } })
        return result
        // await dispatch('LogIn', result.result.token)
    },

    async LogIn({commit}, data) {
        //await axios.post("mainContent", user);
        console.log(data.firstName)
        await commit("setName", data.firstName);
        await commit("setUser", data.token);
    },
    logOutAuth({ commit }) {
        commit('deleteUser');
    },
    async CreatePost({ dispatch }, post) {
        await axios.post("post", post);
        return await dispatch("GetPosts");
    },

    async GetPosts({ commit }) {
        let response = await axios.get("posts");
        commit("setPosts", response.data);
    },

    async LogOut({ commit }) {
        let user = null;
        commit("logout", user);
    },
};

const mutations = {
    setUser(state, token) {
       // state.status.loggedIn = true;
        state.user = token;
    },
    setName(state, firstName) {
       // state.status.loggedIn = true;
        state.name = firstName;
    },
    deleteUser(state) {
        // state.status.loggedIn = true;
        state.user = ''
    },
    setPosts(state, posts) {
        state.posts = posts;
    },
    logout(state, user) {
        state.user = user;
    },
};


export default {
    state,
    getters,
    actions,
    mutations,
};
